import React from "react";
import { View } from "react-native";

import { colors } from "../../constants/styles";
import { modalStyles as styles } from "./styles";

type ModalProps = {
  isVisible: boolean;
  backdropOpacity: number;
  children: JSX.Element;
};

const Modal = ({
  backdropOpacity,
  isVisible,
  children,
}: ModalProps): JSX.Element => {
  const backgroundColor = colors.blackAlpha(backdropOpacity);
  return isVisible ? (
    <View style={[styles.container, { backgroundColor }]}>
      <View style={styles.childContainer}>{children}</View>
    </View>
  ) : (
    <></>
  );
};

export default Modal;
